import { Component, Inject, OnInit } from '@angular/core';
import { CaixaService } from 'app/service/caixa/caixa.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl } from '@angular/forms';
import { RgModel } from 'app/model/caixa/rg.model';

@Component({
  selector: 'app-lista-rgs',
  templateUrl: './lista-rgs.component.html',
  styleUrls: ['./lista-rgs.component.scss']
})
export class ListaRgsComponent implements OnInit {
  public rgs;
  public msgVazio = '';
  public loading = true;
  public rgControl = new FormControl('');
  public rg = {} as RgModel;

  constructor(
    public dialogRef: MatDialogRef<ListaRgsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private caixaService: CaixaService) { }

  ngOnInit() {
    this.listarRgs();
  }

  setRG(rg) {
    this.rg = rg;
    this.rgControl.setValue(this.rg.rgRecipiente);
  }

  listarRgs() {
    this.caixaService.listarRgs().subscribe(data => {
      this.rgs = data;
      this.loading = false;
      if (this.rgs.length === 0) {
        this.msgVazio = 'Nenhuma RG Encontrado ! Para gerar RGs válidos acesse o menu lateral.'
      }
    }, err => {
      console.error(err);
      this.loading = false;
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}



// WEBPACK FOOTER //
// /app/src/app/components/caixa/lista-rgs/lista-rgs.component.ts